import {XhrService} from "../ts/xhr.service";
import {addErrorClass} from "./utilities/updateClasses";

// #228601: one request per this many items instead of one request per item.
// Category pages are normally one page of items, but ?no_limit renders a whole
// category on one page, so keep the payload bounded.
const PRICE_BATCH_SIZE = 50;

function setLoadingState(wrapperEl, isLoading) {
    const buttons = wrapperEl.querySelectorAll('.orderButton');
    const qtyInputs = wrapperEl.querySelectorAll('.js-quantity-value');

    buttons.forEach(btn => {
        btn.style.pointerEvents = isLoading ? 'none' : '';
    });
    qtyInputs.forEach(inp => {
        inp.style.pointerEvents = isLoading ? 'none' : '';
    });
}

function loadPricesBatch(entries) {
  const formData = new FormData();
  for (const entry of entries) {
    formData.append('item_ids[]', entry.id);
  }

  return XhrService.generalAjaxCall('loadItemListPrices', formData, 'POST', 'json')
    .then(response => {
      if (!response.status || response.status === 'err') throw 'Could not load prices';
      const items = response.items || {};
      for (const entry of entries) {
        const html = items[String(entry.id)];
        if (html) {
          entry.target.innerHTML = html;
        } else {
          addErrorClass(entry.target);
        }
      }
    })
    .catch(e => {
      for (const entry of entries) {
        addErrorClass(entry.target);
      }
      console.error('Error:', e);
    })
    .finally(() => {
      for (const entry of entries) {
        if (entry.row) setLoadingState(entry.row, false);
      }
    });
}

export function loadPrices(wrapper = document) {
  const entries = [];

  for (let target of wrapper.querySelectorAll('.js-loadPrices')) {
    const id = parseInt(target.dataset.id);
    if (!(id > 0)) continue;

    const row = target.closest('.itemlistElement__wrapper, .itembox');
    if (row) setLoadingState(row, true);

    entries.push({id, target, row});
  }

  for (let i = 0; i < entries.length; i += PRICE_BATCH_SIZE) {
    loadPricesBatch(entries.slice(i, i + PRICE_BATCH_SIZE));
  }
}